// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Typography from "@material-ui/core/Typography";

import type { DispatchType } from "../../global/types/redux";
import { logErrorMessage } from "../../account/actions/profileActions";

type ErrorBoundaryStatesType = {
  hasError: boolean
};

type ErrorBoundaryPropsType = {
  children: React$Node
};

class ErrorBoundary extends Component<
  ErrorBoundaryPropsType,
  ErrorBoundaryStatesType
> {
  constructor(props: ErrorBoundaryPropsType) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error: *, info: *) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    this.log(error, info);
  }

  log = async (error: *, info: *): * => {
    let detail;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      detail = JSON.stringify(info);
    } else {
      //info is useless in production server
      let message = {
        url: window.location.href + "\n",
        browser: window.navigator.userAgent + "\n"
      };
      detail = JSON.stringify(message);
    }
    this.props.actions.logErrorMessage(
      String(error),
      detail,
      (): * => console.log("ErrorBoundary logged")
    );
  };

  render(): * {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Typography variant="h6">
          Something went wrong, please contact the Imagus admin staff.
        </Typography>
      );
    }
    return this.props.children;
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ logErrorMessage }, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(ErrorBoundary);
